import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class AccessoryReportService {
  constructor(private http: HttpUtilService) {}

  AccessoryReport(model: {
    FromDate: string;
    ToDate: string;
    Type: string;
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/AccessoryReport`,
      {
        model: model,
      },
    );
  }
}
